document.addEventListener("DOMContentLoaded", function () {
    window.user_location = user_location;
    new CustomEvent('userLocationReady', window.user_location);
});
